#@import Booking.Collections.Attributes
#@import Booking.Models.Base
#@export Booking.Models.LocalBookingSettings

class Booking.Models.LocalBookingSettings extends Booking.Models.Base

  constructor: (attributes, options) ->
    options = _.extend({}, options, parse: true)
    Booking.Models.Base.call(this, attributes, options)

  parse: (raw) ->
    # Check to see if additional_attributes is already an Attributes Collection (like when rescheduling on My Reservations).
    if raw?.additional_attributes and !(raw.additional_attributes instanceof Booking.Collections.Attributes)
      raw.additional_attributes = new Booking.Collections.Attributes(raw.additional_attributes)

    if raw?.duration
      raw.duration = parseInt(raw.duration, 10)

    raw

  getDefinitionVersion: ->
    @get('definition_version')

  getDuration: ->
    @get('duration')

  getTimezone: ->
    @get('time_zone')

  getAdditionalAttributes: ->
    @get('additional_attributes')

  getAvailability: ->
    @get('availability')

  getMinLeadTime: ->
    @get('min_lead_time')

  getMaxLeadTime: ->
    @get('max_lead_time')

